import React from 'react'
import { graphql } from 'gatsby'

export const AUTHOR_FIELDS = graphql`
  fragment AuthorFields on WpContentNode {
    ... on WpPost {
      author {
        node {
          name
          userProfileInformation {
            title
            userImage {
              sourceUrl
              altText
            }
            socialProfiles {
              link
              image {
                sourceUrl
                altText
              }
            }
          }
        }
      }
    }
    ... on WpProductguide {
      author {
        node {
          name
          userProfileInformation {
            title
            userImage {
              sourceUrl
              altText
            }
            socialProfiles {
              link
              image {
                sourceUrl
                altText
              }
            }
          }
        }
      }
    }
    ... on WpCasestudy {
      author {
        node {
          name
          userProfileInformation {
            title
            userImage {
              sourceUrl
              altText
            }
            socialProfiles {
              link
              image {
                sourceUrl
                altText
              }
            }
          }
        }
      }
    }

    ... on WpInfographic {
      author {
        node {
          name
          userProfileInformation {
            title
            userImage {
              sourceUrl
              altText
            }
            socialProfiles {
              link
              image {
                sourceUrl
                altText
              }
            }
          }
        }
      }
    }
  }
`

const AuthorCard = ({ data, className, nodeType }) => {
  return (
    <div
      className={`author-card rounded-t-2xl overflow-hidden border border-gray-light mb-12 ${className}`}
    >
      <div className='author-card__title body-4 px-6 py-2 bg-blue-tint text-blue'>
        {nodeType === 'Productguide' ? 'Product Support' : 'About the author'}
      </div>
      <div className='author-card__body p-4 flex'>
        {data.userProfileInformation.userImage && (
          <img
            height='80px'
            width='80px'
            className='author-avatar rounded-full h-20 w-20 bg-gray-light mr-4'
            src={data?.userProfileInformation?.userImage?.sourceUrl}
            alt={data?.userProfileInformation?.userImage?.altText}
          />
        )}
        <div className='author-details w-1/2'>
          <div className='author-details__name body-2 mb-2 text-gray'>{data?.name} </div>
          <div
            className='author-details__title body-3 text-gray'
            dangerouslySetInnerHTML={{ __html: data?.userProfileInformation?.title }}
          ></div>
        </div>
      </div>
      {data?.userProfileInformation?.socialProfiles && (
        <div className='author-card__social flex p-3 border-t border-gray-light'>
          {data?.userProfileInformation?.socialProfiles.map((social) => {
            return (
              <a
                className='mr-4'
                key={social?.link}
                href={social?.link}
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  height='24px'
                  width='24px'
                  src={social?.image?.sourceUrl}
                  alt={social?.image?.altText}
                />
              </a>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default AuthorCard
